// الملف الطبي — the clinic layer of the customers module (HANDOFF-erp-web §3,
// §5.4; boards customers/medical--dental-chart, customers/medical--prescription).
//
// FOR THE INTEGRATOR — this folder does not register itself:
//   1. src/features/customers/index.tsx: spread `medicalRoutes` into `routes`
//      and `medicalMenu` into `menu` (after «السجل», before «الاستيراد»).
//   2. src/features/customers/mock/handlers.ts: spread `medicalHandlers`; add
//      `medicalBookHandlers` only where no other module already mocks the
//      bff-business customers timeline/visits/search and bookings/:id paths.
//   3. The menu row and the routes are gated by `erp.medical` AND the business
//      sector (`sectors: MEDICAL_SECTORS`) — a salon never sees the row; a deep
//      link is refused by the shell (and by MedicalGate) → «اليوم» + reason.
//
// Server roles (erp-core): every member (staff+) reads and writes the file;
// the approved drug list is written by manager+ only.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';
import { MEDICAL_SECTORS } from './lib/text';

export { MEDICAL_SECTORS, isMedicalSector } from './lib/text';
export { medicalHandlers, medicalBookHandlers, allMedicalMockRoutes } from './mock/handlers';

export const MEDICAL_FLAG = 'erp.medical';

const routes = () => import('./screens/routes');
const handle = gate({ flag: MEDICAL_FLAG, sectors: MEDICAL_SECTORS });

export const medicalRoutes: RouteObject[] = [
  { path: '/customers/medical', handle, lazy: () => routes().then((m) => ({ Component: m.PatientPickerRoute })) },
  { path: '/customers/:customerId/medical', handle, lazy: () => routes().then((m) => ({ Component: m.ChartRoute })) },
  { path: '/customers/:customerId/medical/visits', handle, lazy: () => routes().then((m) => ({ Component: m.VisitsRoute })) },
  { path: '/customers/:customerId/medical/prescriptions', handle, lazy: () => routes().then((m) => ({ Component: m.PrescriptionsRoute })) },
  { path: '/customers/:customerId/medical/attachments', handle, lazy: () => routes().then((m) => ({ Component: m.AttachmentsRoute })) },
];

export const medicalMenu: MenuItem[] = [
  { key: 'medical', label: 'الملف الطبي', to: '/customers/medical', match: ['/customers/:customerId/medical/*'], flag: MEDICAL_FLAG, sectors: MEDICAL_SECTORS },
];
